export const PricingRoutePath = `${process.env.REACT_APP_HOME_URL}/#Pricing`

export const MediaAudioRoutePath = `${process.env.REACT_APP_TRACK_URL}/track`
